import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EmiComapanyListBoxComponent } from 'app/shared/emi-comapany-list-box/emi-comapany-list-box.component';
import { EmiFooterCallbackBoxComponent } from 'app/shared/emi-footer-callback-box/emi-footer-callback-box.component';
import { EmiHeaderBannerComponent } from 'app/shared/emi-header-banner/emi-header-banner.component';
import { SearchFilterPipe } from 'app/shared/pipes/search-filter';
import { TimeComponent } from 'app/shared/time/time.component';
import { ChartsModule } from 'ng2-charts';


import { TestimonialsComponent } from './testimonials/testimonials.component';
import { WidgetHostDirective } from 'app/shared/widget/widget-host.directive';
import { BankRateCalculationComponent } from "app/calculators/home-loan-comparison-calculator/bank-rate-calculation/bank-rate-calculation.component";
import { OwlModule } from "ng2-owl-carousel";

const MODULES = [FormsModule , ReactiveFormsModule];

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    MODULES,
    ChartsModule,
    OwlModule,

  ],
  declarations: [
    EmiHeaderBannerComponent,
    EmiComapanyListBoxComponent,
    EmiFooterCallbackBoxComponent,
    TestimonialsComponent,
    TimeComponent,
    SearchFilterPipe ,
    WidgetHostDirective,
    BankRateCalculationComponent,
  ],
  exports : [
    EmiHeaderBannerComponent,
    EmiComapanyListBoxComponent,
    EmiFooterCallbackBoxComponent,
    TestimonialsComponent,
    TimeComponent,
    SearchFilterPipe,
    WidgetHostDirective,
    MODULES,
    BankRateCalculationComponent

  ]
})

export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts